import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import JWTService from "./../../services/JWTService"; // Giả sử bạn có service JWT
import { useUser } from "./../../context/UserContext"; // Giả sử bạn dùng Context API để quản lý user

const AuthGuard = ({ children }) => {
    const { user, loginUser } = useUser();// Lấy user từ context (hoặc từ state khác)
    const navigate = useNavigate();

    useEffect(() => {
        if (!user || (user && JWTService.isTokenExpired(user.token))) {
            navigate("/login");
        }
    }, [user, navigate]);

    return <>{children}</>;
};

export default AuthGuard;
